import React from "react";
import { Facebook, MapPin, Waves } from "lucide-react";

const STATUS = {
  AVAILABLE: { cls: "cal-available", label: "Disponible" },
  RESERVED: { cls: "cal-reserved", label: "Réservée" },
  BLOCKED_ADMIN: { cls: "cal-blocked", label: "Bloquée" },
  OUT_OF_SEASON: { cls: "cal-out", label: "Hors saison" },
  TEMPORARY_HOLD: { cls: "cal-hold", label: "En attente" },
};

export function BookingCalendar({ days, month, year, selected, onSelect, adminMode = false, onAdminToggle }) {
  const first = new Date(year, month, 1);
  const startDow = (first.getDay() + 6) % 7; // Monday=0
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const map = Object.fromEntries(days.map(d => [d.date, d.status]));
  const cells = [];
  for (let i = 0; i < startDow; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) {
    const iso = `${year}-${String(month+1).padStart(2,"0")}-${String(d).padStart(2,"0")}`;
    cells.push({ d, iso, status: map[iso] || "OUT_OF_SEASON" });
  }
  const dayNames = ["Lun","Mar","Mer","Jeu","Ven","Sam","Dim"];
  return (
    <div>
      <div className="grid grid-cols-7 gap-1 mb-1 text-xs text-stone-500 font-semibold text-center">
        {dayNames.map(n => <div key={n}>{n}</div>)}
      </div>
      <div className="grid grid-cols-7 gap-1">
        {cells.map((c, i) => {
          if (!c) return <div key={i} className="cal-cell cal-empty" />;
          const s = STATUS[c.status] || STATUS.OUT_OF_SEASON;
          const isSelected = selected === c.iso;
          const clickable = adminMode ? (c.status === "AVAILABLE" || c.status === "BLOCKED_ADMIN" || c.status === "TEMPORARY_HOLD") : c.status === "AVAILABLE";
          return (
            <button
              key={c.iso}
              disabled={!clickable}
              onClick={() => {
                if (adminMode) onAdminToggle && onAdminToggle(c.iso, c.status);
                else if (clickable) onSelect && onSelect(c.iso);
              }}
              data-testid={`cal-day-${c.iso}`}
              title={`${c.iso} — ${s.label}`}
              className={`cal-cell ${isSelected ? "cal-selected" : s.cls} ${!clickable ? "opacity-90" : ""}`}>
              {c.d}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export function CalendarLegend() {
  return (
    <div className="flex flex-wrap gap-3 text-xs mt-3" data-testid="calendar-legend">
      <span className="inline-flex items-center gap-1.5"><span className="w-4 h-4 rounded bg-emerald-200 border border-emerald-400"></span> Disponible</span>
      <span className="inline-flex items-center gap-1.5"><span className="w-4 h-4 rounded bg-red-200 border border-red-400"></span> Réservée / Bloquée</span>
      <span className="inline-flex items-center gap-1.5"><span className="w-4 h-4 rounded bg-stone-200 border border-stone-300"></span> Hors saison</span>
    </div>
  );
}

export function MonthNav({ month, year, onChange }) {
  const label = new Date(year, month, 1).toLocaleDateString("fr-FR", { month: "long", year: "numeric" });
  return (
    <div className="flex items-center justify-between mb-3">
      <button data-testid="cal-prev" onClick={() => { const d = new Date(year, month-1, 1); onChange(d.getMonth(), d.getFullYear()); }} className="px-3 py-1.5 text-sm border rounded-md hover:bg-stone-50">← Mois précédent</button>
      <div className="font-serif text-lg capitalize text-emerald-900">{label}</div>
      <button data-testid="cal-next" onClick={() => { const d = new Date(year, month+1, 1); onChange(d.getMonth(), d.getFullYear()); }} className="px-3 py-1.5 text-sm border rounded-md hover:bg-stone-50">Mois suivant →</button>
    </div>
  );
}
